import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiButton } from '@taiga-ui/core';

import { ListModeSwitcherComponent } from './list-mode-switcher.component';

@NgModule({
  declarations: [ListModeSwitcherComponent],
  imports: [CommonModule, TuiButton],
  exports: [ListModeSwitcherComponent],
})
export class ListModeSwitcherModule {}
